module.exports = __webpack_public_path__ + "static/media/47.35cd42df.jpg";